module.exports = __webpack_public_path__ + "media/images/button-plus-c9e0c9c10ef57c5f6ec3fcc0d441f247.png";